import SaaRetireIndex from "components/templates/common/SAA/retire/Index";

export default function SaaRetireSurvey({
  isMobile,
  surveyList,
}: {
  isMobile: boolean;
  surveyList: any;
}) {
  return (
    <main className="min-w-[360px] max-w-[800px] w-screen bg-bg ">
      <SaaRetireIndex isMobile={isMobile} surveyList={surveyList} />
    </main>
  );
}
